/**
 * A dashed-border placeholder card that appears in an empty cell when the user
 * clicks "+" to add a shift. It acts as a visual anchor for the
 * QuickActionsPopover and is replaced by a real shift card once the user picks
 * a saved shift.
 *
 * Design specs from Figma node 776-114704:
 * - 2px dashed border, rgba(15, 46, 87, 0.1), dash pattern [6, 6]
 * - 8px border-radius
 * - Full width/height of parent cell (with cell padding applied by wrapper)
 * - Padding: 6px top/bottom, content 0px 6px
 * - Text: Inter 600 12/16 "Shift name", Inter 500 12/16 "00:00 - 00:00"
 * - Color: rgba(1, 27, 75, 0.37)
 */

import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

const GHOST_BORDER_COLOR = 'rgba(15, 46, 87, 0.1)'

const GhostShiftCard = () => (
  <div
    style={{
      width: '100%',
      padding: '6px 0',
      boxSizing: 'border-box',
      border: `2px dashed ${GHOST_BORDER_COLOR}`,
      borderRadius: '8px',
      pointerEvents: 'auto',
    }}
  >
    <Box paddingX="s6">
      <F0Text variant="small" content={i18n.t('shift_management.preview_cell.shift_name')} />
      <F0Text variant="small" content="00:00 - 00:00" />
    </Box>
  </div>
)

export { GhostShiftCard }
